module.exports = __webpack_public_path__ + "static/media/banner4.0df861a0.jpg";